import Dialog from "@Features/dialog/components/Dialog";
import {MutableRefObject} from "react";
import TripleDotLoader from "@Generic/loaders/TripleDotLoader";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";
import PassengerClassSelectModalHeader
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/components/PassengerClassSelectModalHeader";
import PassengerClassSelectModalAddNewGroup
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/components/PassengerClassSelectModalAddNewGroup";
import PassengerClassSelectModalContent
    from "@CheckOrder/features/classPicker/features/additionalPassengerClassSelectModal/components/PassengerClassSelectModalContent";

interface AdditionalPassengerClassSelectModalProps {
    dialogRef: MutableRefObject<HTMLDialogElement>,
    closeModal: () => void,
    passengerId: number,
    selectedPassengerClass: AvailablePassengerClassType | undefined,
    setSelectedPassengerClass: (passengerClass: AvailablePassengerClassType, passengerGroupIndex?: number) => void,
    isReturn?: boolean,
}

function PassengerClassSelectModal(props: AdditionalPassengerClassSelectModalProps) {
    const {
        dialogRef,
        closeModal,
        passengerId,
        selectedPassengerClass,
        setSelectedPassengerClass,
        isReturn,
    } = props

    return (
        <Dialog dialogRef={dialogRef} className="passenger-class__modal">
            <PassengerClassSelectModalHeader
                passengerId={passengerId}
            />
            {selectedPassengerClass ? (
                <>
                    <PassengerClassSelectModalContent
                        closeModal={closeModal}
                        passengerId={passengerId}
                        selectedPassengerClass={selectedPassengerClass}
                        setSelectedPassengerClass={setSelectedPassengerClass}
                        isReturn={isReturn}
                    />
                    <PassengerClassSelectModalAddNewGroup
                        closeModal={closeModal}
                        selectedPassengerClass={selectedPassengerClass}
                        setSelectedPassengerClass={setSelectedPassengerClass}
                    />
                </>
            ) : (
                <TripleDotLoader small/>
            )}
        </Dialog>
    )
}

export default PassengerClassSelectModal